import axios, { AxiosPromise, AxiosInstance } from 'axios';

import { IUploadSubmitResponse, IRefreshedTokenData, IUploadEvent } from './interfaces';
import { useSsoTokenForRequests } from '../../utils/sso';
import { redirectToLoginOnUnauthorized } from './interceptors';
import { Lazy } from '../../cdk/lazy';

export const vaultApi: Lazy<AxiosInstance> = new Lazy(() => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_VAULT_API_URL,
  });

  useSsoTokenForRequests(instance);
  redirectToLoginOnUnauthorized(instance);

  return instance;
});

export const getStatusForUploadId = (uploadId: string): AxiosPromise<IUploadEvent[]> => {
  const url = `/workflows/youtube/upload/status?uploadId=${uploadId}&orderBy=asc`;

  return vaultApi.getInstance().get(url);
};
